import EventRsvpDetail from '@/screens/EventRsvpDetail';

export default function PrivateEventEventIdRsvpIndexRoute() {
  return <EventRsvpDetail />;
}
